export default __webpack_public_path__ + "static/media/ashirvadPortrait.a960f0e8.png";